<template>
    <div :id="id" class="directive flex-y-center m-flex-center" :style="`width: ${Width()}`">
        <div :class="['align-c item', Classes().itemLeft]">
            <p>
                <img :src="IconSource()" :alt="`Icon - ${directive.Name}`" :title="directive.Name" width="100" height="100"/>
            </p>
            <p class="m-no-margin-l name">{{ directive.Name }}</p>
            <div class="directive-split m-no-margin-t p-mobile" v-if="index < totalDirectives - 1"></div>
        </div>
        <div class="directive-split p-desktop" v-if="index < totalDirectives - 1"></div>
    </div>
</template>

<script>
import { Animation } from "@/assets/JS/Animation.js";
import { CONFIG } from "@/assets/JS/Config.js";
import $ from "jquery";
import { projectModel } from "@/models";

export default {
    name: "ProjectDetailDirectivesDirective",
    props: {
        id: String,
        directive: Object,
        totalDirectives: Number,
        index: Number,
        contentInitiated: Boolean,
        mobile: Boolean
    },
    methods: {
        LastItem: function() { return this.index === this.totalDirectives - 1; },
        Width: function() {
            if (!this.mobile) {
                return !this.LastItem() ? `${100 / this.totalDirectives}%` : "auto";
            }
            return "100%";
        },
        Classes: function() {
            return {
                itemLeft: this.LastItem() ? "left" : ""
            };
        },
        IconSource: function() {
            return require(`@/assets/Images/Directives/${this.directive.IconSource}`);
        },
        AnimateIn: function() {
            const $instance = $(`#${this.id}`);
            const $directive = $instance.find(".item");
            const instance = this;
            new Animation(
                $directive,
                "Fade",
                1,
                !this.contentInitiated
                    ? CONFIG.projects.detailContentAnimationSpeed
                    : 0,
                0,
                function() {
                    if (instance.index === 0) {
                        instance.$emit("content-initiated", "Directives");
                    }
                }
            );
            const scaleDirection = !this.mobile ? "Width" : "Height";
            const scaleAmount = !this.mobile ? "100%" : "150px";
            new Animation(
                $instance.find(".directive-split"),
                scaleDirection,
                scaleAmount,
                !this.contentInitiated
                    ? CONFIG.projects.detailContentAnimationSpeed
                    : 0,
                0
            );
        }
    },
    mounted: function() { this.AnimateIn(); },
    updated: function() { this.AnimateIn(); },
    emits: [ ...projectModel.emits ]
};
</script>